import _extends from "@babel/runtime/helpers/esm/extends";
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
const baseSlots = {
  baseButton: Button,
  baseIconButton: IconButton
};
const iconSlots = {};
export const defaultSlotsMaterial = _extends({}, baseSlots, iconSlots);